import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import { useAdjustmentsModalStore } from '@app/application/adjustments/store/adjustment-modal'

export default function useModalGridTemplate(): {
  gridTemplate: ComputedRef<string>
} {
  const modalStore = useAdjustmentsModalStore()
  const { columns } = storeToRefs(modalStore)

  const breakpoints = useBreakpoints(breakpointsTailwind)

  const gridTemplate = computed(() => {
    return breakpoints.isGreater('xl')
      ? `repeat(2, 3fr) repeat(${columns.value.length - 3}, 1fr) 40px`
      : `repeat(2, 2fr) repeat(${columns.value.length - 3}, 1fr) 40px`
  })

  return {
    gridTemplate,
  }
}
